var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',[(_vm.type === 'wells')?_c('WellsBadges',{attrs:{"is_on_sale":_vm.is_on_sale,"is_new":_vm.is_new,"is_top":_vm.is_top,"is_out_of_stock":_vm.is_out_of_stock,"discount_percentage":_vm.discount_percentage}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }